import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";
import SearchIcon from "@FRAMEWORK/ui/mobile/icon/SearchIcon";
import {TextInput} from "@FRAMEWORK/ui/mobile/input";
import {Select} from "@FRAMEWORK/ui/mobile/select";
import dayjs, {Dayjs} from "dayjs";
import {useEffect, useState} from "react";
import {FILTER_ALL} from ".";
import LocalFilterCalendar from "../LocalFilterCalendar";

interface Props {
	handleMonth: (val: string) => void;
	dataStr: string;
	outStartDate: {value: string; text: string};
	removeOutStartDate: () => void;
	handleCalendar: (date: string) => void;
}

const getMonthStr = (str: string) => `${str.substring(0, 4)}년${str.substring(4, 6)}월`;

const DepartureDateComponent = ({dataStr, handleMonth, outStartDate, removeOutStartDate, handleCalendar}: Props) => {
	const monList = dataStr.replaceAll("|", "").split("^");
	const [minDate, setMinDate] = useState<string>();
	const [maxDate, setMaxDate] = useState<string>();
	const [showCalendar, setShowCalendar] = useState(false);
	const onCalendarClick = () => {
		setShowCalendar(!showCalendar);
	};

	// 달력, 기본값 초기화
	useEffect(() => {
		if (monList) {
			const [firstMon, lastMon] = [monList[0], monList[monList.length - 1]];
			setMinDate(firstMon);
			setMaxDate(lastMon);
		}
	}, [monList, outStartDate.value]);

	return (
		<>
			<style.InputWrap>
				{/* 출발월 선택 */}
				<Select onChange={e => handleMonth(e.target.value)} value={outStartDate.value}>
					<option value={FILTER_ALL}>출발 월 전체</option>
					{monList.map((month, idx) => (
						<option key={idx} value={month}>
							{getMonthStr(month)}
						</option>
					))}
				</Select>
				{/* 출발일 선택 */}
				<style.CalendarInput>
					<TextInput
						readOnly
						placeholder="출발일 선택"
						value={outStartDate.value?.length === 8 ? dayjs(outStartDate.value).format("YYYY.MM.DD") : ""}
						onClick={onCalendarClick}
					/>
					<SearchIcon icon="calendar" />
				</style.CalendarInput>
			</style.InputWrap>
			{showCalendar && (
				<LocalFilterCalendar
					minDate={minDate}
					maxDate={maxDate}
					value={outStartDate.value}
					onDateChange={(date: Dayjs) => {
						if (date === null) {
							removeOutStartDate();
							return;
						}
						const thisDate = date ? date.format("YYYYMMDD") : "";
						handleCalendar(thisDate);
					}}
					data={{handleClose: () => setShowCalendar(false)}}
				/>
			)}
		</>
	);
};

const DepartureDate = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter DeparetureDate Error">
		<DepartureDateComponent {...props} />
	</ErrorBoundary>
);

export default DepartureDate;
